<div
  class="rounded-md border-4 border-dashed p-4 transition-all"
  [class]="variant() === 'STOM' ? 'border-rose-500 bg-rose-500/50' : 'border-emerald-500 bg-emerald-500/50'"
>
  <ng-content></ng-content>
</div>
